import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import moment from "moment/moment";
import config from "config/config";
import { getToken } from "js/formatting/getToken";

export const getAgent = createAsyncThunk(
  "getAgent",
  async (agentData, { rejectWithValue, fulfillWithValue }) => {
    const { agentId } = agentData;
    try {
      let options = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": config.ODS_API_KEY,
          Authorization: `bearer ${getToken()}`,
        },
        body: JSON.stringify({
          gXdpApi: {
            transactionType: {
              eventName: "GETAGENT",
              operation: "GET",
              sourceNameSpace: "ODS",
              targetNameSpace: "GIDP",
            },
            gIdpPayLoad: {
              addOnProperties: {
                lifesys: {
                  policyHolder: {
                    system: "LSN",
                    lifeSysDataset: "A",
                    company: config.COMPANY,
                    clientName: config.CLIENTNAME,
                    showLogTimeStamp: "",
                  },
                },
              },
              agent: {
                agentId: agentId,
              },
            },
            addOnProperties: {},
            correlationID: moment().format("YYYY-MM-DD HH:MM:SS"),
          },
        }),
      };
      const response = await fetch(
        config.ODS_API_BASE_URL + "/ce-callerVerification/GetAgent",
        options
      );
      const data = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          return rejectWithValue(response.status);
        } else {
          return rejectWithValue(response.status);
        }
      } else return fulfillWithValue(data.gXdpApi.gIdpPayLoad.agents);
    } catch (error) {
      if (error.status === 401) {
        rejectWithValue(error.message);
      } else throw rejectWithValue(error.message);
    }
  }
);
const agentSlice = createSlice({
  name: "Agent",
  initialState: {
    isLoading: false,
    error: "",
    agent: [],
  },
  extraReducers: {
    [getAgent.pending]: (state) => {
      state.isLoading = true;
    },
    [getAgent.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.meta.arg.updateStore) {
        state.agent = action.payload;
      }
    },
    [getAgent.rejected]: (state, action) => {
      state.isLoading = false;
      state.error = action;
    },
  },
});

export default agentSlice.reducer;
